import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import {
  DEFAULT_LOCALE,
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
  normalizeLocale,
} from './constants'

import enCommon from './locales/en/common.json'
import enMarketing from './locales/en/marketing.json'
import enWorkspace from './locales/en/workspace.json'
import jaCommon from './locales/ja/common.json'
import jaMarketing from './locales/ja/marketing.json'
import jaWorkspace from './locales/ja/workspace.json'
import zhCommon from './locales/zh/common.json'
import zhMarketing from './locales/zh/marketing.json'
import zhWorkspace from './locales/zh/workspace.json'

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, marketing: enMarketing, workspace: enWorkspace },
      ja: { common: jaCommon, marketing: jaMarketing, workspace: jaWorkspace },
      zh: { common: zhCommon, marketing: zhMarketing, workspace: zhWorkspace },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    ns: ['common', 'marketing', 'workspace'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeLocale,
    },
  })

i18n.on('languageChanged', (lng) => {
  const normalized = normalizeLocale(lng)
  document.documentElement.lang = normalized
  if (normalized !== lng) {
    void i18n.changeLanguage(normalized)
  }
})

document.documentElement.lang = normalizeLocale(i18n.language)

export default i18n
